export default {
  currentBreadcrumb: (state) => (state.items.length === 0 ? undefined : state.items[state.items.length - 1]),
  currentBreadcrumbKey: (state, getters) => getters.currentBreadcrumb?.key,
  currentBreadcrumbName: (state, getters) => getters.currentBreadcrumb?.name ?? '',
  breadcrumbItems: (state) => state.items,
}
